var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMoonCoin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 595,
    height: 595,
    viewBox: "0 0 595 595",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M507.772 87.0421L507.674 87.1402C453.772 33.3003 379.39 0 297.5 0L13.0553 13.0919L0 297.494C0 379.272 32.9942 453.345 86.4058 507.124L86.504 507.025C140.468 561.356 215.192 595 297.5 595L581.945 581.908L595 297.494C595 215.286 561.662 140.882 507.76 87.0298L507.772 87.0421ZM475.894 384.892C458.189 425.517 425.538 458.167 384.9 475.885C210.37 551.945 43.0557 384.634 119.118 210.108C136.823 169.483 169.474 136.833 210.1 119.128C384.63 43.067 551.944 210.378 475.882 384.904L475.894 384.892Z",
    fill: "#FFFFFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoonCoin);
export default __webpack_public_path__ + "static/media/moon-coin.32b34ed1d32daa31e5810c0a3234826e.svg";
export { ForwardRef as ReactComponent };